/* @flow */
import React from 'react';
import { withRouter } from 'app/context/Router';

type Props = {
  router: *,
  params: *,
};

class IntegrationPageIndex extends React.Component<Props, {}> {
  componentDidMount() {
    this.props.router.replace(`/integrations/${this.props.params.uuid}/content`);
  }

  render() {
    return null;
  }
}

export { IntegrationPageIndex };
export default withRouter(IntegrationPageIndex);
